import * as React from 'react';
import classNames from 'classnames';

import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

const styles = require('./styles.pcss');

const TravelerTableHead = () => (
  <TableHead>
    <TableRow>
      <TableCell className={classNames(styles.tableHead)}>First Name</TableCell>
      <TableCell className={classNames(styles.tableHead)}>Last Name</TableCell>
      <TableCell className={classNames(styles.tableHead)}>Email</TableCell>
      <TableCell className={classNames(styles.tableHead)}>Status</TableCell>
    </TableRow>
  </TableHead>
);

export default TravelerTableHead;
